<template>
  <v-dialog v-model="dialog.show" :max-width="dialog.maxWidth" persistent>
    <component :is="dialog.name"></component>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

import Login from './elements/Login.vue'
import Logout from './elements/Logout.vue'

import Source from './elements/Source.vue'
import SetPassword from './elements/SetPassword.vue'
import GameDetail from './elements/GameDetail.vue'

export default {
  name: 'Dialog',

  components: {
    Login,
    Logout,
    Source,
    SetPassword,
    GameDetail
  },

  data() {
    return {}
  },

  computed: {
    ...mapState('common', ['dialog'])
  }
}
</script>

<style lang="scss" scoped>
</style>
